import { createTypedOutlet } from "src/router";

import { Contract } from "./types";

export type ContractOutletContext = {
  contract: Contract;
};

const {
  OutletProvider: ContractOutlet,
  ContextProvider: ContractContextProvider,
  useContext: useContractOutletContext,
  useOptionalContext: useContractOutletContextIfAvailable,
} = createTypedOutlet<ContractOutletContext>("Contract");

export {
  ContractOutlet,
  ContractContextProvider,
  useContractOutletContext,
  useContractOutletContextIfAvailable,
};
